// ======================================================================
// File Name       : question
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================


import * as ActionTypes from '../../constants/actionTypes/question';

export function getAttributeList(attributeList) {
  return {
    type: ActionTypes.GET_ATTRIBUTE_LIST,
    attributeList,
  };
}

export function getAttributeListDialog(attributeList) {
  return {
    type: ActionTypes.GET_ATTRIBUTE_LIST_DIALOG,
    attributeList,
  };
}
